import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { Spinner } from 'app/components/organisms';
import { BootstrapService } from '@venecia/services';
import { AppInitializer } from './app.init';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Spinner, TranslateModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly bootstrap = inject(BootstrapService);
  private readonly appInitializer = inject(AppInitializer);

  protected readonly title = signal('Venecia Identity Center');

  constructor() {
  }

  async ngOnInit(): Promise<void> {
    await this.appInitializer.initialize();
  }
}
